import { IJamaItem } from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import { TReactSelectOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import {
	IkrStatuses,
	IrlaStatuses,
	ICalendar,
	TDay,
	TDeadlines,
	TptkmConfig,
	IptkmFormConfig,
	TptkmStatuses,
	TPriorityField,
	THours,
	IHour,
	THourType,
} from "./ptkmStore"

type TDefaultAllJamaItems = {
	fetched: boolean
	ALL: IJamaItem[]
}
// */
export const defaultAllJamaItems: TDefaultAllJamaItems = {
	fetched: false,
	ALL: [],
}
export interface IStatusField {
	fieldId: string
	name: string
}

const testRLAhours: IHour = {}
const testKRhours: IHour = {}

const testRLAKRHours: THours = {
	rlaHours: testRLAhours,
	krHours: testKRhours,
}
export const defaultSingleRlaKrHours: THourType = {
	singleDimension: testRLAKRHours,
}
export const defaultPriorityField: TPriorityField = {
	fieldKey: "",
	rlaKrHours: defaultSingleRlaKrHours,
	secondFieldKey: "",
}

export const defaultDeadlines: TDeadlines = {
	priorityField: defaultPriorityField,
}

export const defaultStatusFieldFormData: IStatusField = {
	fieldId: "",
	name: "",
}

export const defaultPtkmStatuses: TptkmStatuses = {
	statusPickList: defaultStatusFieldFormData,

	startStatus: null,
	pauseStatus: null,
	krStopStatus: null,
	rlaStopStatus: null,

	startWhenFieldHasValues: defaultStatusFieldFormData,
}

export const defaultRlaStatuses: IrlaStatuses = {
	rlaField: undefined,
	unedited: undefined,
	submitted: undefined,
	xHoursLeft: undefined,
	late: undefined,
	submittedLate: undefined,
	customHours: undefined,
	rlaDeadlineDateField: undefined,
}
export const defaultKrStatuses: IkrStatuses = {
	krField: undefined,
	unedited: undefined,
	submitted: undefined,
	xHoursLeft: undefined,
	late: undefined,
	submittedLate: undefined,
	notRequired: undefined,
	customHours: undefined,
	krDeadlineDateField: undefined,
}

export const defaultFormData: IptkmFormConfig = {
	item: "",
	itemId: "",
	project: "",
	projectId: "",
	id: "",
	name: "",
	position: 0,
	isActive: false,
	deadlines: defaultDeadlines,
	status: defaultPtkmStatuses,
	results: {
		rlaStatuses: defaultRlaStatuses,
		krStatuses: defaultKrStatuses,
	},
}

export const defaultCopyFormData: IptkmFormConfig | undefined = undefined

/**
 * Calendar
 */

export const defaultWorkingDay: TDay = {
	start: "09:00",
	end: "17:00",
	workingDay: true,
}

const defaultWeekend: TDay = {
	workingDay: false,
}
export const defaultCalendar: ICalendar = {
	week: {
		monday: defaultWorkingDay,
		tuesday: defaultWorkingDay,
		wednesday: defaultWorkingDay,
		thursday: defaultWorkingDay,
		friday: defaultWorkingDay,
		saturday: defaultWeekend,
		sunday: defaultWeekend,
	},
	holidays: "",
	transferedDays: "",
}
/**
 * Full default config
 */
const defaultPtkmConfig: TptkmConfig = {
	formsConfigsPTKM: [],
	calendar: defaultCalendar,
}

export default defaultPtkmConfig
